module.exports = __webpack_public_path__ + "img/52-r.5a0e2680.png";